import React, { useContext, useState } from 'react';
import PhoneTextField from '@/components/NumberFormat/phoneTextField';
import { AuthContext } from '@/contexts/AuthContext';
import { Toast } from '@/lib/Toast';
import { api } from '@/services/apiClient';
import { phoneMask } from '@/utils/masks';
import { KeyboardBackspace } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
  useTheme,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { destroyCookie } from 'nookies';

interface ChangeMobileProps {
  isOpen: boolean;
  onSuccess: () => void;
  onClose: () => void;
}

export default function ChangeMobile({
  isOpen,
  onSuccess,
  onClose,
}: ChangeMobileProps) {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { user, setUser } = useContext(AuthContext);

  const [errorNumber, setErrorNumber] = useState(false);
  const [number, setNumber] = useState(user.phone?.replace(/55/, '') || '');
  const [loading, setLoading] = useState(false);

  const handleChangeMobile = () => {
    setLoading(true);
    if (number && number !== phoneMask(user?.phone || '')) {
      api
        .put('/auth/users/me/', {
          username: user?.username,
          name: user?.name,
          email: user?.email,
          phone: number,
        })
        .then(response => {
          if (response.status === 200) {
            setLoading(false);
            setUser(response.data);
            Toast(
              'success',
              'Celular alterado com sucesso! Valide seu telefone para receber todas as atualizações!'
            );
            onSuccess();
            destroyCookie(null, 'PHONE_CHECK_ACTIVE');
          }
        })
        .catch(error => {
          setLoading(false);
          if (error.response?.status === 400) {
            if (error.response.data?.phone) {
              Toast('error', `Celular: ${error.response.data.phone[0]}`);
            }
            return;
          }
          Toast('error', 'Ocorreu um erro!');
        });
    } else {
      setErrorNumber(true);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal open={isOpen}>
        <Box
          sx={{
            backgroundColor: smUp ? '' : '#00A8F3',
            height: '100%',
            width: '100%',
            pt: 4,
            display: smUp ? 'flex' : 'block',
            justifyContent: smUp ? 'center' : '',
            alignItems: smUp ? 'center' : '',
          }}
        >
          <Box
            sx={{
              height: smUp ? '528px' : '100%',
              width: smUp ? '426px' : '100%',
              backgroundColor: '#FFFFFF',
              borderRadius: smUp ? '12px' : '12px 12px 0 0',
              padding: smUp ? '38px' : '16px',
              position: 'relative',
            }}
          >
            <IconButton
              sx={smUp ? { position: 'absolute', right: 16, top: 16 } : {}}
              onClick={() => {
                onClose();
              }}
              data-testid="button-close-modal"
            >
              {smUp ? (
                <CloseIcon />
              ) : (
                <KeyboardBackspace sx={{ color: '#000000' }} />
              )}
            </IconButton>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: 'calc(100% - 150px)',
                mt: smUp ? 3 : 0,
              }}
            >
              <Box sx={{ width: '100%', mb: 2 }}>
                <Typography
                  sx={{ mb: 1, fontWeight: '700' }}
                  color="#808080"
                  variant="h5"
                >
                  Informe seu celular
                </Typography>
                <PhoneTextField
                  error={errorNumber}
                  helperText={
                    errorNumber && number.length === 15
                      ? 'O número informado é o mesmo já cadastrado!'
                      : errorNumber &&
                        number === '' &&
                        'O campo deve estar preenchido!'
                  }
                  label="Celular"
                  variant="standard"
                  value={number}
                  onValueChange={value => {
                    setErrorNumber(false);
                    setNumber(value);
                  }}
                />
                <Typography variant="caption" sx={{ mb: 2 }} color="#808080">
                  Informe seu número novo de celular.
                </Typography>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  width: 'calc(100% - 32px)',
                  mb: 4,
                }}
              >
                <LoadingButton
                  loading={loading}
                  sx={{ mb: 3 }}
                  variant="contained"
                  fullWidth
                  onClick={handleChangeMobile}
                >
                  alterar
                </LoadingButton>
                <Button
                  data-testid="button-cancel-modal"
                  variant="outlined"
                  fullWidth
                  onClick={onClose}
                >
                  cancelar
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export type { ChangeMobileProps };
